var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('p',{staticClass:"footer__copyright"},[_vm._v(" Copyright © "+_vm._s(_vm.getYear())+" Techtonic. All Rights Reserved. Privacy Policy. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }